import { useAuth } from 'react-oidc-context';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import posthog from 'posthog-js';

export function Logout() {
  const auth = useAuth();
  const isAuthenticated = auth.isAuthenticated;
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const toPage = queryParams.get('topage');
  const logoutExecuted = useRef(false);

  useEffect(() => {
    if (logoutExecuted.current) {
      return;
    }

    logoutExecuted.current = true;

    localStorage.clear();
    posthog.reset();
    dispatch({ type: 'RESET_DATA' });

    const queryString = toPage ? `?topage=${toPage}` : '';
    if (!isAuthenticated) {
      history.push('/login');
    }

    auth.signoutRedirect({
      post_logout_redirect_uri: `${window.location.origin}/login${queryString}`,
      id_token_hint: auth.user?.id_token,
    });
  }, [auth, isAuthenticated, dispatch, history, toPage]);

  return null;
}
